module.exports = __webpack_public_path__ + "assets/osde-alt.243fd9c5.svg";